import http from '@/communication/AuthConnection'

export default async ({ state, commit }, { eventId, rule }) => {
  try {
    await http.post(`/v1/item-pricing/${eventId}/minimum/rule`, {
      rule
    })
    return true
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/apply-minimum-rule/index.js